import React from 'react';
import EmailBanner from '../EmailBanner/EmailBanner.jsx';
import { addLeadEmail } from 'ck-core-client/source/functions/addLeadEmail';
import { Trackers } from 'ck-core-client/source/trackers/Trackers';

interface Props {
	trackers: Trackers;
}

export const LeadCaptureEmailBanner: React.SFC<Props> = ({ trackers }) => {
	const inEmailTest = CK.fn.inTest('EmailCaptureIncentive');

	const messageLang = inEmailTest
		? 'Sign up to learn more about Code Kingdoms and get 10% off!'
		: 'Enter your email to learn more about Code Kingdoms and how to get set up!';

	const titleLang = inEmailTest ? 'Save 10%!' : 'Want in?';

	const postSignupLang = inEmailTest
		? `Thanks for signing up! Check your inbox to redeem your discount.`
		: `Thanks, we've emailed you instructions on how to get started!`;

	return (
		<EmailBanner
			close
			title={titleLang}
			subtitle={messageLang}
			buttonText="Sign me up"
			emailText="Enter your email address"
			confirmationText={postSignupLang}
			backgroundImg="bg-red-circle"
			buttonColour="yellow"
			handleSubmit={val => addLeadEmail(val, trackers, inEmailTest)}
		/>
	);
};
